import {useState} from 'react'
import {Building2, User} from 'lucide-react'
import './assets/css/form1.css'
import Logo from '../../../_metronic/assets/logo.png'
import {useNavigate} from 'react-router-dom'

export default function BusinessTypeSelector() {
  const [selectedType, setSelectedType] = useState<'corporate' | 'freelancer' | ''>('')
  const router = useNavigate()

  const handleNextPage = () => {
    if (!selectedType) return
    router(`/become-a-merchant/merchant-form-2?type=${selectedType}`)
  }

  return (
    <>
      <div className='d-flex flex-column flex-root px-10 d-flex' id='kt_app_root'>
        <div className='flex-column flex-column-fluid' id='kt_app_page'>
          <div className='d-flex flex-column gap-10'>
            <div
              className='container-fluid pt-8'
              id='kt_app_header_container'
              style={{
                zIndex: 1000,
              }}
            >
              <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                <a href='/sign-in'>
                  <img alt='Logo' src={Logo} style={{width: 150}} />
                </a>
              </div>

              <div className='mt-10'>
                <a href='/sign-in' className='d-flex align-items-center gap-3'>
                  <i className='bi bi-chevron-left fs-4 text-black'></i>
                  <span className='text-black fs-3 fw-bold'>Back</span>
                </a>
              </div>
            </div>

            <div className='d-flex flex-column flex-root px-10 d-flex gap-10'>
              <div
                className=''
                style={{
                  width: '100%',
                }}
              >
                <div className='card d-flex py-10'>
                  <div className='card-body mx-15 space-y-8 d-flex flex-column'>
                    <div className='w-75'>
                      <h1 className='fs-2 fw-normal'>
                        Whether you&apos;re a business looking to manage services for multiple team
                        members or an freelancer wanting full control over your own services,
                        we&apos;re here to provide you with a seamless experience.
                      </h1>
                    </div>

                    <div className='gap-5 justify-content-center align-items-center h-100 w-100'>
                      <p className='text-black fs-2x mx-auto mt-10 fw-bold'>
                        Please select the business type that best suits your needs
                      </p>
                      <div className='d-flex gap-20 mt-15 px-0 w-75'>
                        {['corporate', 'freelancer'].map((type) => (
                          <div key={type} className='w-50 h-100 px-0' id={`${type}-card`}>
                            <div
                              className={`card card-bordered border-primary border-2 w-100 h-100 cursor-pointer transition-all duration-300 cardHover ${
                                selectedType === type ? 'primary-styles' : 'primary-not-selected'
                              }`}
                              onClick={() => setSelectedType(type as 'corporate' | 'freelancer')}
                            >
                              <div className='card-body p-6'>
                                <div className='d-flex flex-column align-items-center gap-3'>
                                  <h2 className='fs-3x font-semibold text-primary'>
                                    {type === 'corporate' ? 'Corporate' : 'Freelancer'}
                                  </h2>
                                </div>
                                <p className='text-muted-foreground fs-2 mt-5'>
                                  {type === 'corporate'
                                    ? "Choose this option if you're a business looking to streamline your services. You can create memberships and campaigns, track progress together."
                                    : "Choose this option if you're signing up as a freelancer. Enjoy the flexibility to manage your personal services and memberships and track usage with ease."}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className='d-flex mt-20'>
                      <div className='d-flex justify-content-start align-items-start mt-2 gap-10'>
                        <div className='w-100 d-flex justify-content-center'>
                          <button
                            type='submit'
                            className='btn btn-dark w-100 py-5 px-20'
                            disabled={!selectedType}
                            onClick={handleNextPage}
                          >
                            {/* Continue */}
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
